import {
  MANAGER,
  ACCOUNT
} from '../../../gameday/data/gameDay-data.calculation';
import { AccountManager } from '../../../state/data/state';
import { GameDayModel } from '../../../models/gameday-model';

interface ExtractedAccount {
  account: string;
  priority: GameDayModel.AccountPriority;
}

export function extractAccounts(
  orders: GameDayModel.Order[]
): ExtractedAccount[] {
  const result = new Map<string, ExtractedAccount>();

  orders.forEach((order: GameDayModel.Order) => {
    // TODO: remove filtering by account when services will have normal data
    if (order.firmId && !!order.accountName && !result.has(order.accountName)) {
      result.set(order.accountName, {
        account: order.accountName,
        priority: order.accountInfo.priority
      });
    }
  });

  return Array.from(result.values());
}

function byKeyComparer(key: string) {
  return <T>(x: T, y: T): number => {
    if (x[key] < y[key]) {
      return -1;
    }
    if (x[key] > y[key]) {
      return 1;
    }
    return 0;
  };
}

export function getAccountsManagers(
  data: GameDayModel.RawData
): AccountManager[] {
  const accounts: AccountManager[] = extractAccounts(data.orders.slice())
    .sort(byKeyComparer('account'))
    .map(({ account, priority }, id) => ({
      id,
      type: ACCOUNT,
      name: account,
      priority
    }));
  const managers: AccountManager[] = data.deal.syndicate
    .slice()
    .sort(byKeyComparer('name'))
    .map((manager) => ({
      type: MANAGER,
      name: manager.name,
      id: manager.id
    }));

  return managers.concat(accounts);
}
